import Image from "next/image";
import Link from "@components/ui/link";
import cn from "classnames";
import { siteSettings } from "@settings/site.settings";
import { useSettings } from "@contexts/settings.context";

const Logo: React.FC<React.AnchorHTMLAttributes<{}>> = ({
  className,
  ...props
}) => {
  const { siteTitle } = useSettings();
  return (
    <Link
      href={siteSettings.logo.href}
      className={cn("inline-flex", className)}
      {...props}
    >
      <span
        className="flex justify-center overflow-hidden relative"
        style={{
          width: siteSettings.logo.width,
          height: siteSettings.logo.height,
        }}
      >
        <img
          src={siteSettings.logo.url}
          alt={siteTitle ?? siteSettings.logo.alt}
          className="h-full"
        />
      </span>
    </Link>
  );
};

export default Logo;
